module.exports = __webpack_public_path__ + "img/140.bd188ce2.jpg";